<template>
  <div ref="ElementoGrafico">  
    <canvas ref="Canvas" :width="WidthGrafico" :height="HeightGrafico + 50"></canvas>
  </div>      
</template>

<script>
// import { TZGraphMarkup, TZGraphLabelType, TZGraphLine, TZGraphNotchType } from '@/utils/ZGraph.js'
// import { TZGraph } from '@/utils/ZGraph.js'
import { TZGraphLine } from '@/utils/ZGraph.js'
import { TZGraphNotchType, TZGraphLabelType } from '@/utils/ZGraph.js'
import { TZDateFunct } from '@/utils/ZDateFunct'
import { TInfoGraphic } from '../../InfoGraphic.js'
import { TZMathFunct } from '@/utils/ZMathFunct'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { TIPI_UDM_X, SystemInformation, SPESSORE_LINEE_GRAFICI } from '@/SystemInformation'

export default 
{
  components: { },
  mixins: [ MixInsGestioneTraduzioni ],
  data() 
  {
    return {
              ObjGrafico      : null,
              Grafici         : {},
              LinguaUtente    : SystemInformation.UserInformation.Lingua,
              SpessoreGrafico : SPESSORE_LINEE_GRAFICI,
              FirstAdatta     : true
           }

  },
  props: [ 
            "WidthGrafico", 
            "HeightGrafico", 
            "ListaModuli", 
            "ObjDal", 
            "ObjAl", 
            "TipoGrafico", 
            "PropsGrafico", 
            "Repaint", 
            "GraficiChange", 
            "PressAdatta",
         ],
  methods:
  {

    Adatta(MaxAsseY, MinAsseY, UdmY)
    {
      //Asse X
      this.ObjGrafico.AxisX.Min           = Date.parse(this.ObjDal.Data + 'T' + (this.ObjDal.Ora < 10? '0' + this.ObjDal.Ora : this.ObjDal.Ora) + ':00')
      this.ObjGrafico.AxisX.Max           = Date.parse(this.ObjAl.Data + 'T' + (this.ObjAl.Ora < 10? '0' + this.ObjAl.Ora : this.ObjAl.Ora) + ':00')
      this.ObjGrafico.AxisX.Max           = this.ObjGrafico.AxisX.Max + TZDateFunct.GetNHoursInTimeStamp(1)
      this.ObjGrafico.AxisX.NotchDim      = (Math.abs(this.ObjGrafico.AxisX.Max - this.ObjGrafico.AxisX.Min))
      this.ObjGrafico.AxisX.NotchDim      = TInfoGraphic.GetAdjustedNotchDim(this.ObjGrafico.AxisX.NotchDim, 24)
      this.ObjGrafico.AxisX.OffsetNotch   = this.ObjGrafico.AxisX.NotchDim
      this.ObjGrafico.AxisX.LabelType     = TZGraphLabelType.lblDateTime
      this.ObjGrafico.AxisX.NotchFontSize = 13
      this.ObjGrafico.AxisX.FontSize      = 15

      //Asse Y
      this.ObjGrafico.AxisY.Max           = MaxAsseY
      this.ObjGrafico.AxisY.Min           = MinAsseY
      this.ObjGrafico.AxisY.NotchDim      = UdmY
      this.ObjGrafico.AxisY.OffsetNotch   = Math.abs(MinAsseY) - TZMathFunct.GetMultiplo(Math.abs(MinAsseY), UdmY, 'Difetto')
      this.ObjGrafico.AxisY.LabelType     = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))

      if(this.FirstAdatta)
      {
        this.ObjGrafico.__Margins.MinBottom += 40
        this.FirstAdatta = false
      }

      setTimeout(() => { this.ObjGrafico.Paint() }, 1)
    },


    Disegna()
    {
      this.Adatta(this.PropsGrafico.AxisY.Max, this.PropsGrafico.AxisY.Min, this.PropsGrafico.AxisY.Udm)

      this.InserisciDati()
      setTimeout(() => { this.ObjGrafico.Paint()})
    },

    InserisciDati()
    {
      this.Grafici = {}
      this.ObjGrafico.ClearAllGroupPoint()
          
      for (let i = 0; i < this.ListaModuli.length; i++)
      {
        this.Grafici['Spostamento' + this.ListaModuli[i].Id] = this.ObjGrafico.AddGroupPoint(1, this.PropsGrafico.ListaModuli[i].Colore, this.SpessoreGrafico, this.PropsGrafico.ListaModuli[i].Visualizzato)
        
        for (let j = 0; j < this.ListaModuli[i].Dati.length; j++)
        {
          let Dato   = this.ListaModuli[i].Dati[j]
          let XCoord = Date.parse(Dato.Data)
          this.Grafici['Spostamento' + this.ListaModuli[i].Id].AddPoint(XCoord, Dato.Spostamento)
        }
      }
    },

  },

  computed:
  {
    GraphData : 
    {
      get()
      {
        return this.PropsGrafico
      }
    }
  },

  watch:
  {
    Repaint:
    {
      handler()
      {
        for (let i = 0; i < this.ListaModuli.length; i++)
        {
          this.Grafici['Spostamento' + this.ListaModuli[i].Id].Visible = this.PropsGrafico.ListaModuli[i].Visualizzato
          this.Grafici['Spostamento' + this.ListaModuli[i].Id].Color   = this.PropsGrafico.ListaModuli[i].Colore
        }

        this.Adatta(this.PropsGrafico.AxisY.Max, this.PropsGrafico.AxisY.Min, this.PropsGrafico.AxisY.Udm)

        if (this.PropsGrafico.AxisX.Modificato)
        {
          let NewUdm = 0
          switch (this.PropsGrafico.AxisX.TipoUdmX)
          {
            case TIPI_UDM_X.Giorni  : {
                                        NewUdm = this.PropsGrafico.AxisX.UdmX * 86400000
                                        break
                                      }
            case TIPI_UDM_X.Ore     : {
                                        NewUdm = this.PropsGrafico.AxisX.UdmX * 3600000
                                        break
                                      }
            case TIPI_UDM_X.Minuti  : {
                                        NewUdm = this.PropsGrafico.AxisX.UdmX * 60000
                                        break
                                      }
            default                 : NewUdm = this.PropsGrafico.AxisX.UdmX
          }
          this.ObjGrafico.AxisX.OffsetNotch = 0
          this.ObjGrafico.AxisX.NotchDim    = NewUdm
        }

        setTimeout(() => { this.ObjGrafico.Paint()})
      }
    },

    GraficiChange:
    {
      handler()
      {
        this.Disegna()
      }
    },

    PressAdatta:
    {
      handler()
      {
        this.Disegna()
      }
    },
  },

  mounted()
  {
    this.ObjGrafico  = new TZGraphLine(this.$refs.Canvas)
    this.GraphData.OggettoGrafico = this.ObjGrafico

    this.ObjGrafico.VerticalLabelAxisX  = true
    this.ObjGrafico.DrawMarkup          = false
    this.ObjGrafico.AxisY.CenterLabel   = this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTO',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('UdmGenerali','TKN_MILLIMETRI',this.LinguaUtente) + ']'
    this.ObjGrafico.AxisX.NotchType     = TZGraphNotchType.notStandard
    this.ObjGrafico.AxisY.NotchType     = TZGraphNotchType.notStandard
    if(this.ObjGrafico.AxisY.NotchDim != undefined)
      this.ObjGrafico.AxisY.LabelType    = SystemInformation.ConvertDigitToLabelType(TZMathFunct.GetNumeroDecimali(this.ObjGrafico.AxisY.NotchDim))
    this.ObjGrafico.AxisX.LabelType     = TZGraphLabelType.lblDateTime
    this.ObjGrafico.AxisY.NotchFontSize = 13
    this.ObjGrafico.AxisY.FontSize      = 13
    this.ObjGrafico.AxisX.NotchPenWidth = 1
    this.ObjGrafico.AxisY.NotchPenWidth = 1
    this.ObjGrafico.AxisX.NotchColor    = 'grey'
    this.ObjGrafico.AxisY.NotchColor    = 'grey'
    this.ObjGrafico.__Margins.MinLeft   += 30

    this.Disegna()
    // setTimeout(() => { this.PaintCanvas() }, 1)
  },

}
</script>